import {createSelector, createSlice} from '@reduxjs/toolkit';
import {RootState} from '../../../app/store';
import {voiceMenuComplete} from "../dataNav";
import {NavList} from "../Header";
import {selectFilterAuthRoute} from "../../reducer/route/routeSlice";


export interface MenuState {
    voiceMenu: NavList[]
}

const initialState: MenuState = {
    voiceMenu: voiceMenuComplete,
};


export const menuSlice = createSlice({
    name: 'menu',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {

    },
});

// export const {
//
// } = routeSlice.actions;






export const selectMenuComplete = (state: RootState) => state.menu.voiceMenu;
export const selectMenuVoices = createSelector(selectMenuComplete, selectFilterAuthRoute, (menu, filterRoute) => {
    if(filterRoute) {
        const list = filterRoute.list.map(ele => ele.name)
        return menu.map(ele => ({...ele, ...(ele.child? {child: ele.child.filter(el => list.includes(el.name))} : {})})).filter(ele => ele.child? ele.child.length : list.includes(ele.name))
    }else {
        return []
    }

})



export default menuSlice.reducer;
